<template>
  <pop-up
    title="Provider Details"
    button-text="Edit"
    class="top-fade-in details"
    @close="$emit('close')"
    @add="editProvider"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <loading-page
        v-if="gettingProvider"
        class="loading m-0 p-0"
      />
      <div
        v-else
        class="container"
      >
        <overview />
      </div>
    </transition>
  </pop-up>
</template>

<script>
import redirectError from '@/services/redirectError'
import Overview from './Details.vue'
import PopUp from '@/components/popup/Pop-up.vue'

export default {
  name: 'ProviderDetails',
  components: { Overview, PopUp },
  props: {
    providerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      providerType: null,
      id: null,
      hasProviderPermissions: true,
    }
  },
  computed: {
    gettingProvider() {
      return this.$store.state.providers.gettingProvider
    },
    provider() {
      return this.$store.state.providers.provider
    },
  },
  created() {
    this.id = this.providerId
    this.getProvider()
  },
  methods: {
    getProvider() {
      this.$store
        .dispatch('providers/getProvider', this.id)
        .then(() => {
          this.providerType = this.provider.typeOptions.find(
            e => e.id === this.provider.type,
          )
        })
        .catch(error => {
          if (error.response?.status === 403) {
            this.hasProviderPermissions = false
            return
          }
          redirectError(error)
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching provider!',
          )
        })
    },
    editProvider() {
      this.$emit('editProvider', this.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.loading::v-deep {
  padding: 1.5rem !important;
}
.details {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
